import React from 'react'
import QS from 'qs'
import { useSelector } from 'react-redux'

import { getAction } from '../../../../ducks/actions'
import Modal from '../../../Shared/Modal'
import Card from '../../../Shared/Card'
import EmptyState from '../../../Shared/EmptyState'
import { RunAction } from '../../../Actions/Run'

export default function ActionModal({ match, history }) {
  const { actionId } = match.params
  const { data } = QS.parse(window.location.search, { ignoreQueryPrefix: true })

  const action = useSelector(getAction(actionId))

  const baseURL = window.location.pathname.split(/\/actions\//)[0]

  const handleClose = () => {
    history.replace(baseURL)
  }

  if (!action) {
    return (
      <Modal onClose={handleClose}>
        <Card>
          <EmptyState loading />
        </Card>
      </Modal>
    )
  }

  return (
    <Modal onClose={handleClose}>
      <RunAction
        doneRedirectReplaceState
        actionId={actionId}
        presetValues={data}
        doneRedirect={baseURL}
      />
    </Modal>
  )
}
